export const SET_MEDIATHEK = 'mediathek/SET_MEDIATHEK'
export const RESET_MEDIATHEK = 'mediathek/RESET_MEDIATHEK'
export const SET_ERRORS = 'mediathek/SET_ERRORS'
export const INITIATE_REQUEST = 'mediathek/INITIATE_REQUEST'
